// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3564":"css/app.6780","7175":"css/admin-app.6780"}[chunkId] + ".css";
};